import React from 'react';

import './App.css';

import Pagination from '../components/Pagination';
import Page from '../components/Page';
import Footer from '../components/Footer';

import pages from '../content/mary_shellys_frankenstein.json';

export default class App extends React.Component {
  constructor() {
    super();
    this.containerRef = React.createRef(null);

    const arr = []

    Object.keys(pages).forEach(key => arr.push({name: key, value: pages[key]}))

    this.state = {
      items: arr,
      pageOfItems: []
    };

    this.onChangePage = this.onChangePage.bind(this);
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems });
  }

  componentDidUpdate() {
    this.containerRef.current.scrollIntoView();
  }

  render() {
    return (
      <div ref={this.containerRef} className="Container">
        {this.state.pageOfItems.map((item, index) => {
          return (
            <Page key={index} item={item} />
          );
        })}
        <Pagination items={this.state.items} onChangePage={this.onChangePage} />
        <Footer />
      </div>
    );
  }
}
